import { View } from "binder"
import { ActivityTypeEditorViewModel } from "./activityTypeEditor-viewModel"

export class ActivityTypeEditorView extends View<ActivityTypeEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-0FB4FAA2-F0C8-413D-B114-AA9CAE6D027E"
    }
    loadHtml(): string {
        let element = require('./activityTypeEditor.html').default;
        let style = require('./activityTypeEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
